import script from "./SheetMusicSong.vue?vue&type=script&setup=true&lang=ts"
export * from "./SheetMusicSong.vue?vue&type=script&setup=true&lang=ts"

import "./SheetMusicSong.vue?vue&type=style&index=0&id=9785e57e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/deployJob/project/music-teach/h5-internal-examination/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9785e57e"]])

export default __exports__